import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { UiNotificationService } from '../../services/ui-notification.service';
import { ApiService } from '../../services/api.service';
import { BreathExercise, BreathSession } from '../../models/summary';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { TabsModule } from 'primeng/tabs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { HttpErrorResponse } from '@angular/common/http';
import { DurationPipe } from '../../utilities/date-pipes';
import { TableModule } from 'primeng/table';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-breath-session-dialog',
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    TranslatePipe,
    DividerModule,
    ProgressSpinnerModule,
    TabsModule,
    DurationPipe,
    TableModule,
    ButtonModule
  ],
  templateUrl: './breath-session-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class BreathSessionDialogComponent implements OnChanges {
  @Input() messageService!: UiNotificationService;
  @Input() session: BreathSession = Reset.breathSession();

  // visibilità dialog (bidirezionale)
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  // evento finale
  @Output() closed = new EventEmitter<BreathSession>();

  loading: boolean = false;
  exercises: BreathExercise[] = [];

  tabsId: string = '';

  constructor(private apiService: ApiService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['session'] && this.session) {
      if (this.session.userId !== '' && this.session.sessionId !== '')
      {
        this.loading = true;

        this.apiService.getPatientBreathExercises(this.session.userId, this.session.sessionId, this.session.timeStamp).subscribe({
          next: (e) => {
            this.exercises = e;
            this.tabsId = this.exercises.length > 0 ? this.exercises[0].exerciseId : '';

            this.loading = false
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false
            this.messageService.showError(err);
          }
        });
      }
    }
  }

  onClose() {
    this.closed.emit(this.session);

    this.visible = false;
    this.visibleChange.emit(false);
  }

  onShowReport(){
    const timestamp: number = new Date(this.session.timeStamp).getTime();
    const timestampEnd: number = timestamp + this.session.duration;
    this.apiService.getPatientDocument(this.session.userId, timestamp, timestampEnd, 4). subscribe({
      next: (blob: Blob) => {
        const fileBlob = new Blob([blob], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(fileBlob);
        
        // Apre in una nuova scheda
        window.open(fileURL, '_blank');
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.showError(err);
      }
    });
  }
}
